import {
  GET_UPDATE_APPROVAL_DATA_START,
  GET_UPDATE_APPROVAL_DATA_SUCCESS,
  GET_UPDATE_APPROVAL_DATA_ERROR,
} from "../Constants/UpdateApprovalConstant";

const initialState = {
  updateLoading: false,
  data: null,
};

export default function UpdateApprovalReducer(
  state = { ...initialState },
  action
) {
  switch (action.type) {
    case GET_UPDATE_APPROVAL_DATA_START:
      return {
        ...state,
        updateLoading: true,
      };
    case GET_UPDATE_APPROVAL_DATA_SUCCESS:
      return {
        ...state,
        data: action.payload,
        updateLoading: false,
      };
    case GET_UPDATE_APPROVAL_DATA_ERROR:
      return {
        ...state,
        updateLoading: false,
        message: action.error.message,
      };

    default:
      return state;
  }
}
